import { em, rem } from 'polished'
import styled, { css } from 'styled-components'

import { type ITimelineEventProps } from '../components/TimelineEvent'
import { IconComponentStyled } from '@ui/elements/Icon'

export interface ITimelineEventStyledProps {
  status: ITimelineEventProps['status']
  iconCircle: ITimelineEventProps['iconCircle']
}

export const TimelineEventStyled = styled.div<ITimelineEventStyledProps>`
  font-size: ${rem(12)};
  position: relative;
  padding: 1em 1.5em 2em 4em;

  .gradient-line {
    visibility: hidden;
    position: absolute;
    left: ${em(18, 12)};
    top: -2.5em;
    height: calc(100% + 2.5em);
    width: ${em(2, 12)};
    background: linear-gradient(
      to bottom,
      transparent,
      ${(props) =>
          props.status
            ? props.theme.colors[props.status]
            : props.theme.colors.disabled}
        25%
    );
  }

  .solid-line {
    position: absolute;
    left: ${em(18, 12)};
    top: 0em;
    height: 100%;
    width: ${em(2, 12)};
    background: ${(props) =>
      props.status
        ? props.theme.colors[props.status]
        : props.theme.colors.disabled};
  }

  .icon {
    position: absolute;
    left: 0;
    top: 1rem;
    background: ${(props) => props.theme.colors.white};

    width: ${em(36, 12)};
    height: ${em(36, 12)};

    text-align: center;

    ${(props) => {
      if (props.iconCircle) {
        return css`
          display: flex;
          align-items: center;
          justify-content: center;

          ${IconComponentStyled} {
            transform: scale(0.5);
          }

          border-radius: 50%;
          border: 2px solid
            ${props.status
              ? props.theme.colors[props.status]
              : props.theme.colors.disabled};
        `
      }
    }}
  }
`
